(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header-mega"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-toggle]').forEach(btn => {
  btn.addEventListener('click', () => {
    const content = btn.nextElementSibling;
    content.classList.toggle('hidden');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider-hero"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper(".mySwiper", {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 20,

  pagination: {
    el: ".swiper-pagination-custom",
    clickable: true,
    bulletClass: "swiper-pagination-bullet",
    bulletActiveClass: "swiper-pagination-bullet-active",
    renderBullet: function (index, className) {
      return `<span class="${className}"></span>`;
    },
  },

  navigation: {
    nextEl: ".swiper-button-next-custom",
    prevEl: ".swiper-button-prev-custom",
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wohnish-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooter = (scope = document) => {
      scope.querySelectorAll('[data-whf-footer]').forEach((footer) => {
        if (footer.dataset.whfReady === 'true') return;
        footer.dataset.whfReady = 'true';

        const columns = [...footer.querySelectorAll('[data-whf-column]')];
        const mobileQuery = window.matchMedia('(max-width: 900px)');

        const setColumnState = (isMobile) => {
          columns.forEach((column) => {
            if (isMobile) column.removeAttribute('open');
            else column.setAttribute('open', '');
          });
        };

        setColumnState(mobileQuery.matches);
        mobileQuery.addEventListener?.('change', (event) => setColumnState(event.matches));

        footer.querySelectorAll('[data-whf-localization-select]').forEach((select) => {
          select.addEventListener('change', () => select.form?.submit());
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initFooter());
    } else {
      initFooter();
    }

    document.addEventListener('shopify:section:load', (event) => initFooter(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wohnish-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMegaHeader = (scope = document) => {
      scope.querySelectorAll('[data-whx-header]').forEach((header) => {
        if (header.dataset.whxReady === 'true') return;
        header.dataset.whxReady = 'true';

        const desktopMenus = [...header.querySelectorAll('[data-whx-nav-details]')];

        desktopMenus.forEach((menu) => {
          menu.addEventListener('toggle', () => {
            if (!menu.open) return;
            desktopMenus.forEach((otherMenu) => {
              if (otherMenu !== menu) otherMenu.removeAttribute('open');
            });
          });
        });

        header.querySelectorAll('[data-w-search-open], [data-w-cart-open], [data-w-menu-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            desktopMenus.forEach((menu) => menu.removeAttribute('open'));
          });
        });

        document.addEventListener('click', (event) => {
          if (!header.contains(event.target)) {
            desktopMenus.forEach((menu) => menu.removeAttribute('open'));
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            desktopMenus.forEach((menu) => menu.removeAttribute('open'));
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initMegaHeader());
    } else {
      initMegaHeader();
    }

    document.addEventListener('shopify:section:load', (event) => initMegaHeader(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
